import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <FAQSection />
        <MediaSection />
        <CarouselSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <ContactSection />
        <TopicsSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}